import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import SupplierSimulator from '../components/procurement/SupplierSimulator';

/**
 * Public demo page — no auth. Investors can play with the Live Simulator
 * directly. Suppliers and simulate-inbound endpoints are already unauthed
 * on the backend, so this page is a thin wrapper.
 */
export default function DemoSimulator() {
  const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

  return (
    <div className="min-h-screen bg-[#050506] text-white">
      {/* Header */}
      <header className="border-b border-white/5 bg-[#050506]/85 backdrop-blur sticky top-0 z-30">
        <div className="mx-auto max-w-[1200px] px-6 h-[64px] flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
              <circle cx="12" cy="12" r="3" fill="currentColor" />
            </svg>
            <span className="text-[15px] tracking-tight">grocera</span>
          </Link>
          <div className="flex items-center gap-3">
            <span className="pill hidden md:inline-flex"><span className="dot-live" /> LIVE DEMO</span>
            <Link to="/login" className="btn-primary text-[12.5px] flex items-center gap-1.5" data-testid="demo-signin">
              Sign in <ArrowRight size={13} />
            </Link>
          </div>
        </div>
      </header>

      <div className="mx-auto max-w-[1200px] px-6 py-8">
        <div className="mb-6">
          <p className="eyebrow mb-2">Try it live · no signup</p>
          <h1 className="h-display text-[36px] md:text-[44px] leading-[1.05]">
            Talk to the Grocera agent, right now.
          </h1>
          <p className="text-white/60 text-[14.5px] mt-3 max-w-[640px] leading-[1.6]">
            Type a WhatsApp message as if you were a supplier at Total Buah Segar and watch the AI agent
            reply in Bahasa Indonesia. Every reply is generated live; every action is logged into the
            same procurement backend a real customer would use.
          </p>
        </div>

        <SupplierSimulator api={API} autoplay={true} />
      </div>

      <footer className="border-t border-white/5 mt-16">
        <div className="mx-auto max-w-[1200px] px-6 py-8 flex flex-wrap items-center justify-between gap-4">
          <div className="mono text-[11px] text-white/45 tracking-widest uppercase">
            © Grocera · procurement agent for grocery supermarkets
          </div>
          <div className="flex items-center gap-3">
            <Link to="/" className="mono text-[11px] text-white/45 hover:text-white/80 tracking-widest uppercase">
              ← Back to site
            </Link>
            <Link to="/login" className="mono text-[11px] text-[#7ba0ff] hover:text-white tracking-widest uppercase">
              Book a demo →
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
